import axiosTokenInstance from "services/api/backoffice";
import {
    OFFER_SIM_PURCHASE,
    OFFER_SIM_PURCHASE_ERROR,
} from "_models/redux/types";

// Action function
export const offersForSimPurchaseAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/callcenter/products/offers-for-sim-purchase`
        );

        const { data, status } = response || {};

        dispatch({
            type: OFFER_SIM_PURCHASE,
            payload: data || {},
            status: status || {},
            method: "get",
        });
    } catch (e) {
        dispatch({
            type: OFFER_SIM_PURCHASE_ERROR,
            payload: e || {},
        });
    }
};
